import React, { useRef } from 'react';
import { Col, Row } from 'reactstrap';
import { FormikProvider, useFormik } from 'formik';
import { caseFileInspectionSchema } from 'app/edozvola/case-file-inspection/model/case-file-inspection.schema';
import { CaseFileInspectionInputModel } from 'app/edozvola/case-file-inspection/model/case-file-inspection.model';
import { useDispatch } from 'react-redux';
import { Button, Input, Label } from 'edozvola-frontend-lib/dist/ui';
import {
  getFileInspectionCaptchaEnabledQuery,
  getFileInspectionDataMutation,
} from 'app/edozvola/case-file-inspection/service/case-file-inspection.queries';
import './case-file-inspection.scss';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from 'app/config/constants';

const CaseFileInspection = () => {
  const dispatch = useDispatch();
  const { mutate: getFileInspectionData, isPending: fetchingFileInspectionDataInProgress } = getFileInspectionDataMutation();
  const { data: isCaptchaEnabled } = getFileInspectionCaptchaEnabledQuery();
  const recaptchaRef = useRef(null);

  const formik = useFormik({
    initialValues: {} as CaseFileInspectionInputModel,
    enableReinitialize: true,
    validateOnMount: true,
    validationSchema: caseFileInspectionSchema(),
    onSubmit: (values: CaseFileInspectionInputModel) => {
      getFileInspectionData(values);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
        formik.setFieldValue('recaptchaToken', null);
      }
    },
  });

  const handleCaptcha = result => {
    formik.setFieldValue('recaptchaToken', result);
  };

  return (
    <>
      <div className={'container-fluid view-container'}>
        <Row>
          <Col md={12}>
            <FormikProvider value={formik}>
              <div className={'d-flex flex-column justify-content-between gap-2'}>
                <div className={'mb-3 form-header'}>Uvid u spis predmeta</div>
                <Row>
                  <Col md={6}>
                    <Label labelText={'Šifra predmeta'} />
                    <Input
                      value={formik.values.webId}
                      onChange={event => formik.setFieldValue('webId', event.target.value)}
                      error={formik.errors.webId}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Label labelText={'Lozinka za uvid u spis'} />
                    <Input
                      value={formik.values.fileInsightPassword}
                      onChange={event => formik.setFieldValue('fileInsightPassword', event.target.value)}
                      error={formik.errors.fileInsightPassword}
                    />
                  </Col>
                </Row>
                {isCaptchaEnabled && (
                  <Row>
                    <Col xs={6}>
                      <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} onChange={handleCaptcha} hl={'hr'} />
                    </Col>
                  </Row>
                )}
              </div>
              <Row className={'mt-4'}>
                <Col md={2}>
                  <Button
                    size={'lg'}
                    color={'info'}
                    label={'Nastavi'}
                    disabled={!formik.dirty || !formik.isValid || (isCaptchaEnabled && !formik.values?.recaptchaToken)}
                    onClick={() => formik.handleSubmit()}
                  />
                </Col>
              </Row>
            </FormikProvider>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CaseFileInspection;
